var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannersEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "banners empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 27,
    y: 0,
    width: 143,
    height: 112,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75,0 L152.25,0 C155.425637,1.63398401e-14 158,2.57436269 158,5.75 L158,104.069598 C158,107.245235 155.425637,109.819598 152.25,109.819598 L5.75,109.819598 C2.57436269,109.819598 8.85050099e-15,107.245235 0,104.069598 L0,5.75 C-3.88903407e-16,2.57436269 2.57436269,5.8335511e-16 5.75,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 29,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75,0 L152.25,-8.8817842e-16 C155.425637,-1.47153353e-15 158,2.57436269 158,5.75 L158,18.9404523 L0,18.9404523 L-8.8817842e-16,5.75 C-1.27708183e-15,2.57436269 2.57436269,-3.04823309e-16 5.75,-8.8817842e-16 Z M6.2781457,7.34425701 L6.2781457,11.5409753 L18.8344371,11.5409753 L18.8344371,7.34425701 L6.2781457,7.34425701 Z M29.2980132,7.34425701 L29.2980132,11.5409753 L41.8543046,11.5409753 L41.8543046,7.34425701 L29.2980132,7.34425701 Z M52.3178808,7.34425701 L52.3178808,11.5409753 L64.8741722,11.5409753 L64.8741722,7.34425701 L52.3178808,7.34425701 Z M148.215283,12.8578422 C150.079834,12.8578422 151.591351,11.3435691 151.591351,9.47561862 C151.591351,7.60766809 150.079834,6.093395 148.215283,6.093395 C146.350732,6.093395 144.839214,7.60766809 144.839214,9.47561862 C144.839214,11.3435691 146.350732,12.8578422 148.215283,12.8578422 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banners-empty"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(72.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-14"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 27.5,
    y: 0.5,
    width: 142,
    height: 111,
    rx: 5.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M5.75,0.5 C2.85050506,0.5 0.5,2.85050506 0.5,5.75 L0.5,104.069598 C0.5,106.969093 2.85050506,109.319598 5.75,109.319598 L152.25,109.319598 C155.149495,109.319598 157.5,106.969093 157.5,104.069598 L157.5,5.75 C157.5,2.85050506 155.149495,0.5 152.25,0.5 L5.75,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 66.000000)",
    fill: "#64808C"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-29",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-29-Copy",
    cx: 12,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-29-Copy-2",
    cx: 22,
    cy: 2,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.8525173,84 L65.4848074,84",
    id: "Line-Copy-2",
    stroke: "#80959D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.883767,84 L140.455638,84",
    id: "Line-Copy-4",
    stroke: "#80959D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5712673,92 L56.7473282,92",
    id: "Line-Copy-3",
    stroke: "#80959D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.571267,92 L130.747328,92",
    id: "Line-Copy-5",
    stroke: "#80959D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-52",
    fill: "#87D5FA",
    x: 10,
    y: 25,
    width: 138,
    height: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(18.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-57"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 22
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-45",
    stroke: "#64808C",
    points: "1 20 10 10 17 18 24 7 28 12"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#64808C",
    cx: 15.5,
    cy: 6.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,35.5 L122.507692,35.5",
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2727273,43 L92.7314683,43",
    id: "Line-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-52-Copy",
    fill: "#EB8181",
    x: 10,
    y: 76,
    width: 24,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-52-Copy-3",
    fill: "#EB8181",
    x: 83,
    y: 76,
    width: 24,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M0.5,18.4404523 L157.5,18.4404523 L157.5,5.75 C157.5,2.85050506 155.149495,0.5 152.25,0.5 L5.75,0.5 C2.85050506,0.5 0.5,2.85050506 0.5,5.75 L0.5,18.4404523 Z M5.7781457,12.0409753 L5.7781457,6.84425701 L19.3344371,6.84425701 L19.3344371,12.0409753 L5.7781457,12.0409753 Z M28.7980132,12.0409753 L28.7980132,6.84425701 L42.3543046,6.84425701 L42.3543046,12.0409753 L28.7980132,12.0409753 Z M51.8178808,12.0409753 L51.8178808,6.84425701 L65.3741722,6.84425701 L65.3741722,12.0409753 L51.8178808,12.0409753 Z M148.215283,13.3578422 C146.074385,13.3578422 144.339214,11.6195078 144.339214,9.47561862 C144.339214,7.3317294 146.074385,5.593395 148.215283,5.593395 C150.35618,5.593395 152.091351,7.3317294 152.091351,9.47561862 C152.091351,11.6195078 150.35618,13.3578422 148.215283,13.3578422 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannersEmpty);
export default __webpack_public_path__ + "static/media/banners_empty.ac0158d66448937c91913c1beafaa58a.svg";
export { ForwardRef as ReactComponent };